export default __webpack_public_path__ + "static/media/Vector2.25ae6861.svg";